<template>
  <div>
    <Hero />
    <Tracks id="releases" :login="login" />
  </div>
</template>

<script>
import Hero from '@/pages/home/Hero'
import Tracks from '@/pages/home/Tracks'

export default {
  name: 'Home',
  props: ['login'],
  components: {
    Hero,
    Tracks
  },
  mounted() {
    if (window.location.hash != null) {
      let url = window.location.hash.replace("#/", '').replace("/", "").split("?")[0]
      if (url == 'new-records') {
        if (document.querySelector('.filter-background')) {
          let top = document.querySelector('.filter-background').getBoundingClientRect().top
          if(this.$mobileDetect.mobile()) {
            TweenMax.to(window, 0, { scrollTo: { y: top }, ease: Quint.easeOut })
          } else {
            TweenMax.to(window, 1, { scrollTo: { y: top }, ease: Quint.easeOut })
          }
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import '../../scss/variables';
</style>



// WEBPACK FOOTER //
// src/pages/home/index.vue